import { TransparentFlatButton } from '@ui/buttons';
import { PrefillQuestionModal } from '@containers/DigitalAnalyst/components/PrefillQuestionModal';
import React from 'react';
import { Field } from './Field';
import { QuestionInput } from './QuestionInput';
import styled from 'styled-components';
import { FormStateContext } from '@/contexts/FormStateContext';
import { ModeContext } from '@/contexts/ModeContext';

const ButtonStyle = styled.div`
  button {
    padding: 4px 4px;
  }
`;
export const PrefilledQuestionInput = () => {
  const [isSelectingPrefillQuestion, setIsSelectingPrefillQuestion] = React.useState(false);
  const { state: formState, setFormStateValue } = React.useContext(FormStateContext);
  const { prefillQuestions, questionLabel = 'Question' } = React.useContext(ModeContext);
  const { question: value } = formState;
  const hasPrefillQuestions = Array.isArray(prefillQuestions) && prefillQuestions.length > 0;

  const onChange = (value) => {
    setFormStateValue('question', value);
  };

  const handleTextInputChange = (e) => {
    const {
      target: { value },
    } = e;
    onChange(value);
  };

  const handleSelectPrefillQuestion = (question) => {
    onChange(question);
    setIsSelectingPrefillQuestion(false);
  };

  return (
    <>
      {isSelectingPrefillQuestion && (
        <PrefillQuestionModal
          onSelect={handleSelectPrefillQuestion}
          onDismiss={() => setIsSelectingPrefillQuestion(false)}
        />
      )}
      <Field
        label={questionLabel}
        labelAction={
          hasPrefillQuestions ? (
            <ButtonStyle>
              <TransparentFlatButton onClick={() => setIsSelectingPrefillQuestion(true)}>
                Use Pre-filled Questions
              </TransparentFlatButton>
            </ButtonStyle>
          ) : undefined
        }
        component={<QuestionInput onChange={handleTextInputChange} value={value} />}
      ></Field>
    </>
  );
};
